module.exports = __webpack_public_path__ + "static/testimonial-visalist-hari-ab5145ef16569a34f460b2c671f216fc.jpg";